/* Assembled in the USA: inline the map, plot it, introduce it in red.

   The extension renders the tagline as a <p> and the map as an <img>. An <img>
   cannot be stroked, hovered or animated, so this fetches the same asset the
   <img> already points at and inlines it. The URL is read off the element, so
   a new asset hash needs no change here.

   THE FILE FIGHTS THE STYLESHEET. Every path carries an inline
   style="stroke-width:0.970631; fill:#f9f9f9", an author declaration that
   beats any stylesheet short of !important. freeUp strips it.

   THE NATIONAL OUTLINE IS NOT IN THE FILE. The map is 51 separate state paths
   and nothing draws the coastline as one shape, so the red edge is built: a
   clone of every state painted BEHIND the real ones with a fat red stroke.
   The real states' white fills cover every interior stroke, leaving only the
   outer half of the stroke, which is the border of the country.

   THE TWO PHASES. The red edge and the black state lines must never share the
   screen. The states' strokes are held invisible while the red draws, then
   inked in as it leaves. The CSS needs to say "the real states, not the
   clones", so the originals are marked fx-usa__st AFTER the clones are taken.

   AND THE INTRO HAS TO END. .is-drawing comes off at HOLD. Leaving it on was
   a live fault: liftOnHover re-appends the hovered path to bring it to the
   front, and moving a node RESTARTS every animation on it, so the ink
   animation went back to its two second delay and the state lines dropped out
   and faded back on every pass of the mouse. With the class gone there is no
   animation left to restart and the strokes simply stay.

   If anything fails the original <img> is left where it was.

   COPY: the heading here is "Shipping to all 50 states.", matching the
   shipping policy (Alaska and Hawaii included from 22 September 2026). The
   extension's locale string still says "Shipping US-wide."; update
   vin_search.hero.tagline on the next extension deploy so the two agree. */
(function () {
  var SCOPE = '.vin-hero-info';
  var HEADING = 'Assembled in the USA.<br>Shipping to all 50 states.';
  var STEP = 0.022;   // seconds between one state and the next, west to east
  var HOLD = 3200;    // ms: the sequence is 3s, then .is-drawing comes off

  function build(info, svgText) {
    if (info.querySelector('.fx-usa')) return;

    var doc = new window.DOMParser().parseFromString(svgText, 'image/svg+xml');
    var svg = doc.querySelector('svg');
    if (!svg || doc.querySelector('parsererror')) return;
    if (!svg.querySelectorAll('path').length) return;

    svg = document.importNode(svg, true);
    svg.setAttribute('class', 'fx-usa__plot');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', 'Map of the United States');

    var tagline = info.querySelector('.vin-hero-tagline');
    var img = info.querySelector('.vin-hero-map');

    var wrap = document.createElement('div');
    wrap.className = 'fx-usa';

    var copy = document.createElement('div');
    copy.innerHTML = '<h2 class="fx-usa__hdg">' + HEADING + '</h2>';

    var art = document.createElement('div');
    art.appendChild(svg);

    wrap.appendChild(copy);
    wrap.appendChild(art);

    var anchor = tagline || img;
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(wrap, anchor);
    if (tagline) tagline.remove();
    if (img) img.remove();

    // West to east, so it reads as one hand crossing the page. Collected
    // BEFORE the halo is built, or the clones join the same query.
    var paths = [].slice.call(svg.querySelectorAll('path'));
    paths.forEach(freeUp);
    paths.sort(function (a, b) {
      try { return a.getBBox().x - b.getBBox().x; } catch (e) { return 0; }
    });

    var lens = [];
    paths.forEach(function (p, i) {
      var len = 0;
      try { len = p.getTotalLength(); } catch (e) { len = 0; }
      lens.push(len);
      if (!len) return;
      p.style.setProperty('--l', len);
      p.style.setProperty('--d', (i * STEP).toFixed(3) + 's');
    });

    buildHalo(svg, paths, lens);

    paths.forEach(function (p) {
      p.setAttribute('class', ((p.getAttribute('class') || '') + ' fx-usa__st').trim());
    });

    liftOnHover(paths);
    arm(svg);
  }

  /* THREE WAYS IN, AND ALL THREE ARE EARNED. An IntersectionObserver reports
     nothing in a tab that is not being painted, and a programmatic scroll does
     not always emit a scroll event either. The poll is the one thing that
     cannot be starved. Whichever fires first tears the other two down. */
  function arm(svg) {
    var done = false;
    var poll = null;
    var ticks = 0;

    function draw() {
      if (done) return;
      done = true;
      svg.classList.add('is-drawing');
      // The intro is over at HOLD and the class has no business outliving it.
      window.setTimeout(function () {
        svg.classList.remove('is-drawing');
        svg.classList.add('is-drawn');
      }, HOLD);
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (poll) window.clearInterval(poll);
    }

    function check() {
      if (done) return;
      var r = svg.getBoundingClientRect();
      if (r.height && r.top < window.innerHeight * 0.9 && r.bottom > 0) draw();
    }

    if (window.IntersectionObserver) {
      var io = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { draw(); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(svg);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);

    poll = window.setInterval(function () {
      ticks++;
      check();
      if (done || ticks > 50) window.clearInterval(poll);
    }, 400);

    check();
  }

  /* Hand the fill and the stroke width back to the stylesheet. The custom
     properties set later live in the same style attribute, so this runs
     before them, not after. */
  function freeUp(p) {
    p.style.removeProperty('fill');
    p.style.removeProperty('stroke');
    p.style.removeProperty('stroke-width');
    p.removeAttribute('fill');
    p.removeAttribute('stroke-width');
  }

  /* Deep clone of the whole drawing, inserted first so it paints underneath.
     Cloning the svg's own children keeps any group transforms intact; ids are
     stripped so nothing is defined twice. */
  function buildHalo(svg, paths, lens) {
    var ns = svg.namespaceURI;
    var halo = document.createElementNS(ns, 'g');
    halo.setAttribute('class', 'fx-usa__halo');
    halo.setAttribute('aria-hidden', 'true');

    [].slice.call(svg.children).forEach(function (node) {
      halo.appendChild(node.cloneNode(true));
    });

    var clones = [].slice.call(halo.querySelectorAll('path'));
    halo.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });

    // The clones came out in document order, not the west to east order the
    // originals were sorted into, so the delay is copied across by position.
    var docOrder = [].slice.call(svg.querySelectorAll('path'));
    var order = {};
    paths.forEach(function (p, i) { order[docOrder.indexOf(p)] = i; });

    clones.forEach(function (c, i) {
      freeUp(c);
      var rank = order[i];
      if (rank === undefined || !lens[rank]) return;
      c.style.setProperty('--l', lens[rank]);
      c.style.setProperty('--d', (rank * STEP).toFixed(3) + 's');
    });

    svg.insertBefore(halo, svg.firstChild);
  }

  /* SVG has no z-index, so a hovered state would be lifted and then painted
     over by whichever neighbour comes later in the file. Moving it to the end
     of its own parent on the way in fixes that. NOTE that this restarts any
     animation on the node, which is why the intro classes must not outlive
     the intro. */
  function liftOnHover(paths) {
    paths.forEach(function (p) {
      p.addEventListener('pointerenter', function () {
        var parent = p.parentNode;
        if (parent && parent.lastElementChild !== p) parent.appendChild(p);
      });
    });
  }

  function start() {
    var info = document.querySelector(SCOPE);
    if (!info || info.querySelector('.fx-usa')) return true;
    var img = info.querySelector('.vin-hero-map');
    if (!img) return false;
    var src = img.getAttribute('src') || img.currentSrc;
    if (!src) return true;
    window.fetch(src, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (t) { build(info, t); })
      .catch(function () { /* leave the flat map in place */ });
    return true;
  }

  function boot() {
    if (start()) return;
    var tries = 0;
    var wait = setInterval(function () {
      tries++;
      if (start() || tries > 40) clearInterval(wait);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
